import { EstimateType } from 'types/store';

const MONTH_HOUR = 120;

export const getMonths = ([min, max]: EstimateType) => {
  const average = (min + max) / 2;
  return Math.trunc(average / MONTH_HOUR);
};
